import React from 'react';
import './FilterCertificateMsg.css';
import { MdClear } from 'react-icons/md';

export const FilterCertificateMsg = ({ filter, close }) => {
  return (
    <div className="rectangle">
      <span><b>{filter}</b></span>
      <MdClear className="clear-icon" size={25} onClick={close} />
    </div>
  );
};

export default FilterCertificateMsg;
